
<app-home-comp1></app-home-comp1>
<app-home-comp2></app-home-comp2>
<!-- <app-home-comp3></app-home-comp3> -->
<!-- <app-home-comp4></app-home-comp4>
<app-home-comp5></app-home-comp5>
<app-home-comp6></app-home-comp6>
<app-home-comp7></app-home-comp7> -->